import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { Tab } from 'react-toolbox/lib/tabs'
import { connect } from 'react-redux'
import { compose } from 'redux'

import List from './List'
import Tabs from './Tabs'
import ListItem from './ListItem'
import { AuthorizedListItem, InternalListItem, ExternalListItem, AdminListItem, DataManagerListItem } from './AuthorizedListItem'
import {
  tabIndexSelector,
} from './selectors'
import {
  toggleNavigationDrawer
} from 'containers/App/App/actions'

import styles from './styles.scss'

const mapStateToProps = (state) => {
  return {
    index: tabIndexSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggle: () => dispatch(toggleNavigationDrawer())
  }
}

const AppNavigation = (props) => {
  const { index, toggle } = props
  return (
    <Tabs index={index}>
      <Tab>
        <List>
          <AuthorizedListItem onClick={toggle} to='/project/create' label='Create Project' />
          <InternalListItem onClick={toggle} to='/project/search' label='Search Projects' />
          <InternalListItem onClick={toggle} to='/myprojects' label='My Projects' />
          <ExternalListItem onClick={toggle} to='/project/list' label='List Projects' />
        </List>
      </Tab>
      <Tab>
        <List theme={styles}>
          {/*<ListItem onClick={toggle} to='/product/create' label='Create Product'/>*/}
          {/*<ListItem onClick={toggle} to='/product/search' label='Search Products'/>*/}
          <ListItem onClick={toggle} to='/product/list' label='List Products' />
        </List>
      </Tab>
      <Tab>
        <List>
          <ListItem onClick={toggle} to='/report/dashboard' label='Dashboard' />
          <ListItem onClick={toggle} to='/report/greenlight' label='Green Light Report' />
          <ListItem onClick={toggle} to='/report/nvqual' label='NVQual Report' />
          <ListItem onClick={toggle} to='/report/weeklystatus' label='Project Weekly Status Report' />
        </List>
      </Tab>
      <Tab>
        <List>
          <ListItem onClick={toggle} to='/manage/nvbugs' label='NVBugs' />
          <ListItem onClick={toggle} to='/manage/nvqualsubmissions' label='NVQual Submissions' />
        </List>
      </Tab>
      <Tab>
        <List>
          <AdminListItem onClick={toggle} to='/admin/products' label='Product SKUs' />
          <AdminListItem onClick={toggle} to='/admin/sites' label='Partner Sites' />
          <DataManagerListItem onClick={toggle} to='/admin/parts_library' label='Parts Library' />
          <AdminListItem onClick={toggle} to='/admin/users' label='NVIDIA Users' />
          <AdminListItem onClick={toggle} to='/admin/clients' label='NVIDIA Partners' />
        </List>
      </Tab>
    </Tabs>
  )
}
const withStyles = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const enhance = compose(
  withConnect,
  withStyles
)
export default enhance(AppNavigation)
